export default __webpack_public_path__ + "static/media/mongodbback.941322b7.svg";